<template>
  <div class="business">
    <el-card class="top"
      ><span>{{ userName }}业务费</span></el-card
    >

    <div class="center">
      <div class="centerContent">
        <div class="planBox">
          <el-divider direction="vertical"></el-divider>
          <span class="titleName">用电信息</span>
          <div class="content topBox">
            <div class="numberInfo">
              <div class="items">
                <div class="label">容量</div>
                <el-input v-model="dataList.capacity" />
                &nbsp;Kw/h
              </div>
              <div class="items">
                <div class="label">线路改造成本</div>
                <el-input v-model="dataList.cost" />&nbsp;元
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-card class="footer"
      ><span>
        <el-button @click="submitBtn(dataList.id)">保存 </el-button>
        <el-button type="success" @click="handleBtn">下一步</el-button></span
      ></el-card
    >
  </div>
</template>

<script>
import { changeStatusApi } from "@/api/energyManagement.js";
export default {
  name: "",
  components: {},
  data() {
    return {
      dataList: {
        capacity: "-",
        cost: "-",
      },

      userName: sessionStorage.getItem("uname") || "",
    };
  },
  mounted() {
    // this.dataList = this.$route.params;
  },
  methods: {
    submitBtn(id) {
      let params = {
        id: id,
        status: 4,
      };
      changeStatusApi(params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("保存成功");
          }
        })
        .catch(() => {});
    },
    handleBtn() {
      this.$router.push({
        name: "contract",
        params: this.$route.params,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business {
  max-width: 1872px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 74px);

  .top {
    width: 100%;
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;

    span {
      color: #333333;
    }
  }

  .center {
    flex: 1;
    box-sizing: border-box;
    width: 100%;
    height: 800px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 0;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    border: none;
    border-radius: 8px;
    padding: 30px;
    .centerContent {
      width: 100%;
      height: 100%;
      .planBox {
        position: relative;
        margin-bottom: 10px;
        .el-divider--vertical {
          display: inline-block;
          width: 3px;
          height: 16px;
          margin: 0;
          margin-bottom: 4px;
          margin-right: 10px;
          vertical-align: middle;
          position: relative;
          border-radius: 3px;
        }

        .titleName {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }
        .topBox {
          height: 268px;
        }
        .content {
          background-color: #ccc;
          width: 100%;
          padding: 0 60px;
          background: inherit;
          background-color: rgba(245, 247, 247, 1);
          box-sizing: border-box;
          border-width: 1px;
          border-style: solid;
          border-color: rgba(207, 217, 215, 1);
          border-radius: 0px;
          .numberInfo {
            display: flex;
            flex-wrap: wrap;
            .items {
              width: 60%;
              height: 80px;
              line-height: 80px;
              position: relative;
              display: flex;
              align-items: center;
              // background-color: red;
              .label {
                border-width: 0px;
                width: 130px;
                height: 32px;
                line-height: 32px;

                font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
                font-weight: 400;
                font-style: normal;
                text-align: right;
                font-size: 14px;
                margin-right: 20px;
                &::after {
                  display: inline-block;
                  content: "：";
                }
              }
              .values {
                width: 50%;
                height: 32px;
                line-height: 32px;
                background: inherit;
                background-color: rgba(255, 255, 255, 1);
                box-sizing: border-box;
                border-width: 1px;
                border-style: solid;
                border-color: rgba(215, 215, 215, 1);
                border-radius: 4px;
                -moz-box-shadow: none;
                -webkit-box-shadow: none;
                box-shadow: none;
                font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
                font-weight: 400;
                font-style: normal;
                color: #9b9f9e;
                text-align: left;
                margin-left: 20px;
              }

              // 上传组件样式
              $uploadBox: 120px;
              .uploadBox {
                width: $uploadBox;
                height: $uploadBox;
                // background-color: pink;
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                background-color: #fff;
                cursor: pointer;
                position: absolute;
                left: 140px;
                top: 23px;
                overflow: hidden;

                .avatar-uploader .el-upload:hover {
                  border-color: #409eff;
                }
                .avatar-uploader-icon {
                  font-size: 28px;
                  color: #8c939d;
                  width: $uploadBox;
                  height: $uploadBox;
                  line-height: $uploadBox;
                  text-align: center;
                }
                .avatar {
                  width: $uploadBox;
                  height: $uploadBox;
                  display: block;
                }
              }
            }
          }
        }
      }
      .baseInfo {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        margin-top: 40px;

        .baseTitle {
          width: 100%;
          display: flex;
          border-bottom: 1px solid #c1c6c5;
          .text {
            font-family: "PingFangSC-Medium", "PingFang SC Medium",
              "PingFang SC", sans-serif;
            font-weight: 500;
            font-style: normal;
            font-size: 16px;
            color: #068d6c;
            // margin-bottom: 5px;
            border-bottom: 3px solid #068d6c;
            padding-right: 10px;
            padding-bottom: 5px;
          }
        }
        .baseContent {
          padding: 30px 20px;
          li {
            list-style: none;
            margin: 30px 0;
          }
          .label {
            color: #333333;
            text-align: right;
            width: 120px;
            display: inline-block;
            &::after {
              display: inline-block;
              content: "：";
            }
          }
          .value {
            color: #8b9996;
            margin-left: 40px;
          }
        }
        // background-color: aqua;
      }
    }
  }
  .footer {
    width: 100%;
    height: 80px;
    position: relative;
    display: flex;
    justify-content: flex-end;
    .el-button {
      width: 140px;
      height: 40px;
      color: #fff;
      background-color: #67c23a;
      border-color: #67c23a;
      // float: right;
      margin-right: 20px;
    }
    .el-button--success {
      width: 140px;
      height: 40px;
      color: #fff;
      background-color: #068d6c;
      border-color: #068d6c;
      // float: right;
      margin-right: 20px;
    }
  }
}
</style>
